import React from 'react'
import { Button, Typography, theme } from 'antd'
import { PlusOutlined, CheckSquareOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const TasksHeader = ({ onAddTask }) => {
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <CheckSquareOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Patient Care Tasks
        </Title>
      </div>
      <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
        <Button
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          onClick={onAddTask}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          New Task
        </Button>
      </div>
    </div>
  )
}

export default TasksHeader
